import React from "react";
import noDataPlaceholder from "../../assets/img/nodata_available.svg";

export interface GainLossItem {
  label: string;   // Generic label (brand, package, category, etc.)
  value: number;   // positive or negative (e.g. 0.7, -2.4)
}

interface Props {
  data: GainLossItem[];
  Title?: string; // overall title for the table
  showSplit?: boolean; // if false → show single table
  valueSuffix?: string; // default: "pp"
}

const GainsLossesTable: React.FC<Props> = ({
  data,
  Title = "Gains and losses",
  showSplit = true,
  valueSuffix = ""
}) => {
  const gains = data
    .filter(item => item.value)
    // .sort((a, b) => b.value - a.value);

  // const losses = data
  //   .filter(item => item.value < 0)
  //   .sort((a, b) => a.value - b.value);

  const renderRow = (item: GainLossItem) => {
    const isPositive = item.value > 0;
    const isZero = item.value === 0;

    return (
      <div key={item.label} style={styles.row}>
        <div style={styles.label}>{item.label}</div>

        <div
          style={{
            ...styles.valueContainer,
            color: isZero ? "#9E9E9E" : isPositive ? "#2E7D32" : "#C62828"
          }}
        >
          <span style={styles.arrow}>
            {isZero ? "●" : (isPositive ? "▲" : "▼")}
          </span>
          <span>
            {Math.abs(item.value).toFixed(2)}
            {valueSuffix}
          </span>
        </div>
      </div>
    );
  };

  if (data.length === 0) {
    return (
      <div style={styles.card}>
        <h3 className="chart-headers" style={{margin: 0}}>{Title}</h3>
        <div style={styles.noDataContainer}>
        <img
          src={noDataPlaceholder}
          alt="No Data"
          style={styles.noDataImage}
        />
      </div>
      </div>
    );
  }

  // if (!showSplit) {
  //   return (
  //     <div style={styles.card}>
  //       <div style={styles.table}>
  //         {data
  //           .sort((a, b) => b.value - a.value)
  //           .map(renderRow)}
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div style={styles.wrapper}>
      {gains.length > 0 && (
        <div style={styles.card}>
          <h3 className="chart-headers" style={{margin: 0}}>{Title}</h3>
          <div style={styles.table}>{gains.map(renderRow)}</div>
        </div>
      )}

      {/*{losses.length > 0 && (*/}
      {/*  <div style={styles.card}>*/}
      {/*    <h3 className="chart-headers" style={{margin: 0}}>{Title}</h3>*/}
      {/*    <div style={styles.table}>{losses.map(renderRow)}</div>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
};

export default GainsLossesTable;

const styles: { [key: string]: React.CSSProperties } = {
  wrapper: {
    display: "flex",
    gap: 24,
    width: "100%",
    flexWrap: "wrap"
  },
  card: {
    flex: 1,
    // minWidth: 300,
    // padding: "20px 24px",
  },
  table: {
    display: "flex",
    flexDirection: "column",
    // gap: 14,
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "4px 0px"
  },
  label: {
    fontSize: 13,
    color: "#333",
    fontWeight: 400
  },
  valueContainer: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    fontWeight: 500
  },
  arrow: {
    fontSize: 11
  },
  noDataContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 80,
    color: "#707070"
  },
  noDataText: {
    fontSize: 14,
    color: "#707070",
    fontWeight: 500
  }
};
